<script>
import Layout from "../../../../layouts/main";
import PageHeader from "@/components/page-header";
import { RestaurantsPath, BrandsPath, PackagingPath } from "@/path.js";
import axios from "axios";
import "vue2-datepicker/index.css";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import Swal from "sweetalert2";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    SelectWithSearch,
    DatePicker,
  },
  computed: {
    RestaurantsPath() {
      return RestaurantsPath;
    },
    BrandsPath() {
      return BrandsPath;
    },
    PackagingPath() {
      return PackagingPath;
    },
  },
  data() {
    return {
      title: "Packaging",
      items: [
        {
          text: "Projection",
        },
        {
          text: "Packaging",
          active: true,
        },
      ],
      baseUrl: process.env.VUE_APP_API_BACKEND_URL,
      restaurant_ids: [],
      brand_ids: [],
      packaging_ids: [],
      gravies: [],
      date_range: null,
      fields: [
        "id",
        "name",
        "total_orders",
        "total_packaging_consumption",
        "stock_sent_(_from_march_1st_2024)",
        "current_stock_as_per_system",
        "current_stock",
        "projected_usage",
      ],
      currentPage: 1,
      key: 1,
      filter: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },
  watch: {
    currentPage() {
      this.getProjection();
    },
  },
  methods: {
    async getProjection() {
      try {
        let res = await axios.get(
          this.baseUrl + PackagingPath.PACKAGING_PROJECTION,
          {
            params: {
              page: this.currentPage,
              restaurant_ids: this.restaurant_ids,
              brand_ids: this.brand_ids,
              packaging_ids: this.packaging_ids,
              date_range:
                this.date_range != null &&
                this.date_range.filter((f) => f != null).length > 0
                  ? [
                      moment(this.date_range[0]).format("YYYY-MM-DD"),
                      moment(this.date_range[1]).format("YYYY-MM-DD"),
                    ]
                  : null,
            },
          }
        );
        if (res.data.status) {
          this.gravies = res.data.data;
          this.gravies.data = this.gravies.data.map((d) => {
            let physical_stock =
              d.current_stock_after_physical + d.physical_stock;
            d.actual_stock_from_our_system = d.current_stock;
            if (d.physical_stock_exists == true) {
              d.current_stock = physical_stock;
            }
            d.c_system_stock =
              parseFloat(
                d.actual_stock_from_our_system - d.total_c_usage
              ).toFixed(0) > 0
                ? Math.ceil(
                    parseFloat(
                      d.actual_stock_from_our_system - d.total_c_usage
                    ).toFixed(0)
                  )
                : 0;
            d.stock_sent =
              parseFloat(d.actual_stock_from_our_system).toFixed(2) > 0
                ? parseFloat(d.actual_stock_from_our_system).toFixed(2)
                : 0;
            d.c_stock =
              parseFloat(d.current_stock - d.total_c_usage_ph_stock).toFixed(
                2
              ) > 0
                ? parseFloat(
                    d.current_stock - d.total_c_usage_ph_stock
                  ).toFixed(2)
                : 0;
            d.projected_usage =
              parseFloat(d.prediction[0]).toFixed(0) - d.c_stock;
            d.projected_usage =
              d.projected_usage < 0 ||
              d.c_stock - Math.ceil(d.projected_usage) >
                Math.ceil(d.projected_usage)
                ? 0
                : d.projected_usage < d.minimum_stock
                ? Math.ceil(d.minimum_stock)
                : Math.ceil(d.projected_usage);
            return d;
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async downloadData(convert = true) {
      try {
        const { value: email } = await Swal.fire({
          title: "Enter Your Email to send consumption email",
          input: "text",
          inputLabel: "email",
          inputValue: "",
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return "Cannot be empty";
            }
          },
        });
        let params = {
          page: this.currentPage,
          no_pagination: true,
          send_email: email,
          restaurant_ids: this.restaurant_ids,
          brand_ids: this.brand_ids,
          packaging_ids: this.packaging_ids,
          date_range:
            this.date_range != null
              ? [
                  moment(this.date_range[0]).format("YYYY-MM-DD"),
                  moment(this.date_range[1]).format("YYYY-MM-DD"),
                ]
              : null,
        };
        if (convert == true) {
          params.convert_to_orders = true;
        }
        let res = await axios.get(
          this.baseUrl + PackagingPath.PACKAGING_PROJECTION,
          {
            params: params,
          }
        );
        if (res.data.status) {
          // res.data.data = res.data.data.map((d) => {
          //   d.total_gravy_consumption = d.units == 'pcs' ?  parseFloat(d.total_usage).toFixed(0) : parseFloat(d.total_usage * 0.001).toFixed(2);
          //   d.current_stock = d.units == 'pcs' ?
          //   (parseFloat(d.current_stock * d.uom - (d.total_c_usage)).toFixed(0) > 0 ?parseFloat(d.current_stock * d.uom - (d.total_c_usage)).toFixed(0) : 0)
          //   :
          //   (parseFloat((d.current_stock) - (d.total_c_usage * 0.001)).toFixed(2) > 0 ? parseFloat((d.current_stock) - (d.total_c_usage * 0.001)).toFixed(2) : 0);
          //   d.projected_usage = d.units == 'pcs' ?
          //   (((parseFloat(d.prediction[0]).toFixed(2)) - (parseFloat(d.current_stock - (d.total_c_usage)).toFixed(2))).toFixed(0) >= 0
          //           ?
          //           (((parseFloat(d.prediction[0]).toFixed(2)) - (parseFloat(d.current_stock - (d.total_c_usage)).toFixed(2))).toFixed(0) > (d.minimum_stock * d.uom) ? ((parseFloat(d.prediction[0]).toFixed(2)) - (parseFloat(d.current_stock - (d.total_c_usage)).toFixed(2))).toFixed(0) : d.minimum_stock * d.uom)
          //            :
          //            0)
          //            :

          //            (((parseFloat(d.prediction[0]).toFixed(2) * 0.001).toFixed(2) - (parseFloat((d.current_stock) - (d.total_c_usage * 0.001)).toFixed(2))).toFixed(2) >= 0
          //           ?
          //           (((parseFloat(d.prediction[0]).toFixed(2) * 0.001).toFixed(2) - (parseFloat((d.current_stock) - (d.total_c_usage * 0.001)).toFixed(2))).toFixed(2) > d.minimum_stock ? ((parseFloat(d.prediction[0]).toFixed(2) * 0.001).toFixed(2) - (parseFloat((d.current_stock) - (d.total_c_usage * 0.001)).toFixed(2))).toFixed(2) : d.minimum_stock)
          //            : 0);
          //   return d;
          // });
          Swal.fire("Data Queued and will be send to email");
        }
        return [];
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(url) {
      // Replace 'your_file_url' with the actual URL of the file you want to download
      this.$refs.download_link.href = url;
      this.$refs.download_link.click();
      // Use the Fetch API to make an HTTP GET request
      // axios.get(fileUrl)
      //     .then(response => {
      //         // Check if the request was successful (status code 200)
      //         if (!response.ok) {
      //             throw new Error(`Failed to download file. Status: ${response.status}`);
      //         }

      //         // Extract the filename from the response headers
      //         const filename = response.headers.get('content-disposition')
      //             .split(';')[1]
      //             .split('filename=')[1]
      //             .trim();

      //         // Convert the response to a blob
      //         return response.blob().then(blob => {
      //             // Create a temporary link element
      //             const link = document.createElement('a');

      //             // Create a URL for the blob
      //             const url = window.URL.createObjectURL(blob);

      //             // Set the link's attributes
      //             link.href = url;
      //             link.download = filename;

      //             // Append the link to the document
      //             document.body.appendChild(link);

      //             // Trigger a click on the link to start the download
      //             link.click();

      //             // Remove the link from the document
      //             document.body.removeChild(link);

      //             // Release the URL object
      //             window.URL.revokeObjectURL(url);
      //         });
      //     })
      //     .catch(error => {
      //         console.error('Error:', error);
      //     });
    },
    async convertToOrders() {
      try {
        let d_range =
          this.date_range != null
            ? [
                moment(this.date_range[0]).format("YYYY-MM-DD"),
                moment(this.date_range[1]).format("YYYY-MM-DD"),
              ]
            : null;
        if (d_range == null) {
          Swal.fire("Date Range Is Required", "", "error");
          return;
        }
        if (this.restaurant_ids.length != 1) {
          Swal.fire("Only One Restaurant Should Be Selected", "", "error");
          return;
        }
        let res = await axios.post(
          this.baseUrl + PackagingPath.PACKAGING_ORDER_AUTO_CREATION,
          {
            restaurant_ids: this.restaurant_ids,
            brand_ids: this.brand_ids,
            packaging_ids: this.packaging_ids,
            date_range: d_range,
          }
        );
        if (res.data.status) {
          Swal.fire("Orders With Projection Data is Created Successfully");
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.$nextTick(async () => {
      this.getProjection();
      // var token = jwt.sign({ foo: 'bar' }, 'shhhhh');
      // console.log(token);
    });
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <b-card-header>
        <b-row>
          <b-col sm="12">Packaging Projection</b-col>
          <b-col sm="3">
            <b-form-group>
              <label>Packagings</label>
              <SelectWithSearch
                :multi_select="true"
                :search_api="PackagingPath.SEARCH_PACKAGING"
                track_by="id"
                display="name"
                @selectedOption="(v) => (packaging_ids = v)"
              ></SelectWithSearch>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group>
              <label>Restaurants</label>
              <SelectWithSearch
                :multi_select="true"
                :search_api="RestaurantsPath.GET_RESTAURANTS"
                track_by="id"
                display="name"
                @selectedOption="(v) => (restaurant_ids = v)"
              ></SelectWithSearch>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group>
              <label>Brands</label>
              <SelectWithSearch
                :multi_select="true"
                :search_api="BrandsPath.BRAND_SEARCH"
                track_by="id"
                display="label"
                @selectedOption="(v) => (brand_ids = v)"
              ></SelectWithSearch>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group>
              <label>Date Range</label>
              <date-picker
                range
                v-model="date_range"
                show-week-number
                :lang="lang"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <b-form-group>
              <b-button @click="getProjection" variant="success"
                >Filter Data</b-button
              >
              <b-button @click="downloadData" variant="success" class="ml-4">
                Send Projection to Email
              </b-button>
              <b-button
                @click="downloadData(true)"
                variant="primary"
                class="ml-4"
              >
                Convert To Orders
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
        <a href="" ref="download_link" class="d-none download"></a>
      </b-card-header>
      <b-card-body :key="key">
        <div class="table-responsive mb-0" :key="key">
          <b-table
            :key="key"
            :items="gravies.data"
            :fields="fields"
            responsive="sm"
            :filter="filter"
            :current-page="currentPage"
          >
            <template v-slot:cell(total_packaging_consumption)="row">
              {{ row.item.total_usage }}
            </template>
            <template v-slot:cell(current_stock_as_per_system)="row">
              {{ row.item.c_system_stock }}
            </template>
            <template v-slot:cell(current_stock)="row">
              {{ row.item.c_stock }}
            </template>
            <template v-slot:cell(stock_sent_(_from_march_1st_2024))="row">
              {{ row.item.stock_sent }}
            </template>
            <template v-slot:cell(projected_usage_original)="row">
              {{ row.item.prediction[0] }}
            </template>
            <template v-slot:cell(projected_usage)="row">
              {{ row.item.projected_usage }}
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  :key="gravies.key"
                  v-model="currentPage"
                  :total-rows="gravies.total"
                  :per-page="gravies.per_page"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </Layout>
</template>
